/**
 * Formats milliseconds into minutes:seconds format
 * @param {number} durationMs - Duration in milliseconds
 * @returns {string} Formatted duration string (e.g., "0:12", "1:32", "12:01")
 */
export const formatDuration = (durationMs) => {
  if (!durationMs || durationMs <= 0) {
    return '0:00';
  }

  const totalSeconds = Math.floor(durationMs / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  return `${minutes}:${seconds.toString().padStart(2, '0')}`;
};

// 2025.7.10 형식의 날짜를 2025-07-10 형식으로 변환
export const formatDateForInput = (dateString) => {
  if (!dateString || typeof dateString !== 'string') return '';

  // Handles YYYY.M.D format
  const parts = dateString.split('.');
  if (parts.length === 3) {
    const [year, month, day] = parts;
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  }

  // Handles ISO string format YYYY-MM-DDTHH:mm:ss.sssZ
  if (dateString.includes('T')) {
    return dateString.split('T')[0];
  }

  return dateString; // Fallback for YYYY-MM-DD or other formats
};

export const capitalize = (string) => {
  if (typeof string !== 'string' || string.length === 0) {
    return string;
  }
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const GRADE_LABELS = {
  STARTER: '스타터',
  LISTENER: '리스너',
  COLLECTOR: '컬렉터',
  CURATOR: '큐레이터',
};

export const categoryFormatter = (category) => {
  if (typeof category !== 'string' || category.length === 0) {
    return category;
  }
  switch (category.toLowerCase()) {
    case 'artists':
      return '아티스트';
    case 'reviews':
      return '앨범';
    case 'news':
      return '뉴스';
    case 'lists':
    case 'mixes':
      return '플리';
    case 'notices':
      return '공지';
    case 'albums':
      return '앨범';
    default:
      return category;
  }
};
